/**
 * The vendored required-elements rule, as the web imports it.
 *
 * `required.js` beside this file is byte-identical to keepr-api's
 * `utils/required/required.js` and must stay that way: the form and the API
 * have to agree about what "required" means, and the only way to guarantee
 * that is one file. Both repos' suites drive the shared `vectors.json`.
 */

import Required from './required';

export const { OPS, isRequiredFor, missingRequired, validateRequiredWhen } = Required;
export default Required;
